<app-expandable-list [sliceLength]="attachmentSliceLength" [allData]="fileData">
  <ng-template let-attachment="data" let-i="index">
    <div class="attachment" (click)="download(attachment)">
      <div class="icon">
        <app-avatar
          icon="attach_file"
          [iconSize]="16"
          [containerSize]="32"
          [containerColor]="'primary'"
          iconColor="white"
        ></app-avatar>
      </div>
      <div class="file-name">
        <span class="file-name__text mat-black">
          {{ attachment.name?.length ? attachment.name : ('label.attachment' | locCap) }}
        </span>
      </div>
      <div *ngIf="showFileSize" class="file-size">{{ attachment.size | fileSize }}</div>
      <div class="buttons">
        <div *ngIf="onEdit.observers.length > 0">
          <mat-icon color="primary" class="cursor-pointer" (click)="onEdit.emit(i)">edit</mat-icon>
        </div>
        <div *ngIf="onDelete.observers.length > 0">
          <mat-icon color="primary" class="cursor-pointer" (click)="delete($event, i)">delete_outline</mat-icon>
        </div>
      </div>
    </div>
  </ng-template>
</app-expandable-list>
